import OutputTypeEditor from './OutputTypeEditorContainer'

export default OutputTypeEditor
